<ng-container *ngIf="isProductionScheduleDisplayOverview; else detailViewMode">
  <svg:svg
    *ngIf="canShowRepeatIndicator()"
    app-production-schedule-item-in-path-group-repeat-indicator
    y="0"
    [quantity]="productionScheduleItem.quantity"
    [productionScheduleItemMultiplier]="productionSchedule.getProductionScheduleItemMultiplier()"
    [cutbarBeforeHeight]="cutbarBeforeHeight"
    [cutbarAfterHeight]="cutbarAfterHeight"
    [drawingHeight]="drawingHeight"
    [totalHeight]="totalHeight"
    [width]="drawingWidth"
  ></svg:svg>
  <svg:svg
    #productionScheduleItemInPathGroup
    app-production-schedule-item-in-path-group
    [isProductionScheduleItemInPathGroupRepetition]="false"
    [productionScheduleItem]="productionScheduleItem"
    [cutbarBeforeHeight]="cutbarBeforeHeight"
    [cutbarAfterHeight]="cutbarAfterHeight"
    [drawingHeight]="drawingHeight"
    [drawingImageHeight]="drawingImageHeight"
    [drawingWidth]="drawingWidth"
    [totalHeight]="totalHeight"
  ></svg:svg>
</ng-container>

<ng-template #detailViewMode>
  <svg:svg
    *ngFor="let repeatedProductionScheduleItem of productionScheduleItem | repeatProductionScheduleItem; let isOriginalProductionScheduleItem = first"
    app-production-schedule-item-in-path-group
    [isProductionScheduleItemInPathGroupRepetition]="!isOriginalProductionScheduleItem"
    [productionScheduleItem]="productionScheduleItem"
    [cutbarBeforeHeight]="cutbarBeforeHeight"
    [cutbarAfterHeight]="cutbarAfterHeight"
    [drawingHeight]="drawingHeight"
    [drawingImageHeight]="drawingImageHeight"
    [drawingWidth]="drawingWidth"
    [totalHeight]="totalHeight"
  ></svg:svg>
</ng-template>
<svg:svg *ngIf="isHoveringItemInPathGroup" class="production-schedule-item-edit-overlay" y="0" height="100%" (click)="openEditProductionScheduleItemDialog($event)">
  <svg:rect width="100%" height="100%"></svg:rect>
  <svg:image x="50%" y="50%" transform="translate(-20, -20)" width="40" height="40" href="../assets/icons/illustrations/edit-with-container.svg"></svg:image>
</svg:svg>
